import type { RiskLevel } from "@clarent/scheduling";
import { RISK_META } from "../lib/risk";

/** Risk pill with a dot, so status never relies on colour alone. `done` shows a grey Done pill instead. */
export function RiskBadge({ risk, done = false, className = "" }: { risk: RiskLevel; done?: boolean; className?: string }) {
  if (done) {
    return (
      <span className={`pill bg-surface text-muted ${className}`}>
        <span className="pill-dot bg-quoted" />
        Done
      </span>
    );
  }
  const meta = RISK_META[risk];
  return (
    <span className={`pill ${meta.pill} ${className}`}>
      <span className={`pill-dot ${meta.dot}`} />
      {meta.label}
    </span>
  );
}
